export default __webpack_public_path__ + "static/media/6b.cbf2ce87.png";